import { DecimalPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { TranslatePipe } from '@ngx-translate/core';
import { UmamiService } from 'core/umami.service';
import { TeamAutoBalanceDataModel } from 'models/matches';
import { AvatarUrlPipe } from 'shared/pipes/avatar-url.pipe';

export interface AutobalanceDataModalContext {
    autoBalanceData: Array<TeamAutoBalanceDataModel>;
}

@Component({
    selector: 'app-autobalance-data-modal',
    imports: [TranslatePipe, MatDialogModule, MatTableModule, MatButtonModule, AvatarUrlPipe, DecimalPipe],
    templateUrl: './autobalance-data-modal.component.html',
    styleUrl: './autobalance-data-modal.component.scss',
})
export class AutobalanceDataModalComponent {
    private readonly context = inject<AutobalanceDataModalContext>(MAT_DIALOG_DATA);
    private readonly umami = inject(UmamiService);

    public readonly autoBalanceData = this.context.autoBalanceData;
    public readonly displayedColumns = ['player1', 'player2', 'withMatchCount', 'againstMatchCount', 'diff', 'ratio'];

    constructor() {
        this.umami.trackEvent('autobalance-data-modal-opened');
    }
}
